// removed by extract-text-webpack-plugin
module.exports = {"sectionsWrapper":"sectionsWrapper__3ustW","chartWrapper":"chartWrapper__2L_Z9","legendWrapper":"legendWrapper__3dJNL"};


//////////////////
// WEBPACK FOOTER
// ./components/pie-chart/style.scss
// module id = V45N
// module chunks = 5